<script setup>
import EventCard from "@/components/EventCard.vue";
import Label from "@/components/ui/label/Label.vue";
import Skeleton from "@/components/ui/skeleton/Skeleton.vue";
import {
  isEventActive,
  isEventUpcoming,
  formatEventDate,
} from "@/lib/dateUtils.js";
import { computed } from "vue";

const props = defineProps({
  activeEvents: Array,
  upcomingEvents: Array,
  isReady: {
    type: Boolean,
    default: false,
  },
  openEventACB: Function,
  signedUpEvents: {
    type: Array,
    default: () => [],
  },
});

function isUserSignedUp(eventId) {
  return props.signedUpEvents.includes(eventId);
}
</script>

<template>
  <div v-if="isReady">
    <div v-if="activeEvents.length > 0" class="lg:px-16">
      <Label for="activeEvents">
        <h1 class="font-bold mb-2 lg:text-2xl">Active Events</h1></Label
      >
      <div id="activeEvents" class="space-y-4 lg:grid lg:grid-cols-3 lg:gap-4">
        <EventCard
          v-for="event in activeEvents"
          :key="event.id"
          :title="event.name"
          :date="formatEventDate(event)"
          :imageUrl="event.imageUrl"
          :signedUp="isUserSignedUp(event.id)"
          @click="openEventACB(event)"
        />
      </div>
    </div>
    <div class="pt-4 lg:px-16" v-if="upcomingEvents.length > 0">
      <Label for="upcomingEvents">
        <h1 class="font-bold mb-2 lg:text-2xl">Upcoming Events</h1></Label
      >
      <div
        id="upcomingEvents"
        class="space-y-4 lg:grid lg:grid-cols-3 lg:gap-4"
      >
        <EventCard
          v-for="event in upcomingEvents"
          :key="event.id"
          :title="event.name"
          :date="formatEventDate(event)"
          :imageUrl="event.imageUrl"
          :signedUp="isUserSignedUp(event.id)"
          @click="openEventACB(event)"
        />
      </div>
    </div>
    <div class="w-full h-14"></div>
  </div>
  <div v-else>
    <div class="lg:px-16">
      <Skeleton class="w-40 h-5 rounded-full mb-5"> </Skeleton>
      <div id="activeEvents" class="space-y-4 lg:grid lg:grid-cols-3 lg:gap-4">
        <Skeleton class="w-full h-32"></Skeleton>
        <Skeleton class="w-full h-32"></Skeleton>
        <Skeleton class="w-full h-32"></Skeleton>
        <Skeleton class="w-full h-32"></Skeleton>
        <Skeleton class="w-full h-32"></Skeleton>
        <Skeleton class="w-full h-32"></Skeleton>
        <Skeleton class="w-full h-32"></Skeleton>
      </div>
    </div>
  </div>
</template>
